import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { UserAlert } from '../../atoms/alerts';
import Bargraph from '../../organisms/BarGraph';
import { HRAImage } from '../../../../assets/images';
import { LodingSquareTabbar } from '../../molecules';
import { DoughnutGraphHRA } from '../../organisms';

const HRA = ({ metricObj, utilizationObj, totalCustomers, sqaureTabHandler, toggleHelp, loading }) => {
  const { donutData, hraCompleted } = metricObj;
  const { barlabels, bardata, barBgColors, xAxesLabel } = utilizationObj;
  const roleflag = ['CSM', 'CSMMaster'].includes(sessionStorage.getItem('role'));
  return (
    <div>
      <div className='mt-8 flex flex-col gap-8 lg:flex-row lg:justify-between'>
        <div className='flex min-w-0 flex-1 flex-col lg:mr-4 lg:w-1/2'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>Percentage of HRA completed</p>
          <DoughnutGraphHRA
            loading={loading}
            loaderHeight={200}
            graphData={donutData}
            hraCompleted={hraCompleted}
            circleTitle='HRA completed'
            title='Number of employees who completed HRA'         
            totalCustomers={metricObj.totalCustomers}
            classes='h-full'
          />
        </div>
        <div className='flex min-w-0 flex-1 flex-col lg:w-2/4'>
          <p className='mb-1 text-xs font-semibold uppercase tracking-wider text-gray-500'>How to improve the utilization</p>
          {!loading ? (
            <div className='h-full rounded-xl border border-gray-200 bg-white p-6 shadow-sm'>
              <img src={HRAImage} alt='india_map' className='mb-4' />

              <p className={`mb-3 text-sm text-gray-500 ${!roleflag && 'mt-8'}`}>
                {roleflag
                  ? 'To improve the utilization of HRA please reach out to the marketing team for a customized plan and share it with your HR'
                  : 'To improve the utilization of HRA please reach out to your customer success manager'}
              </p>
              {!roleflag && (
                <button
                  onClick={() => toggleHelp('Health_Risk_Assessment')}
                  className='block rounded-lg border border-gray-200 px-5 py-3 text-xs font-semibold leading-none text-blue-600 shadow-sm hover:border-gray-400 hover:bg-gray-100 focus:outline-none'
                >
                  Connect with CSM
                </button>
              )}
            </div>
          ) : (
            <Skeleton width='100%' height={200} />
          )}
        </div>
      </div>
      <div className='mt-12 text-xs font-semibold uppercase tracking-wider text-gray-500'>HRA utilization based on</div>
      <LodingSquareTabbar
        list={['Departments', 'Location', 'Age', 'Gender']}
        loaderHeight={30}
        handler={sqaureTabHandler}
        loading={loading}
      />
      <div
        className={
          'mt-4 overflow-hidden rounded-xl border border-gray-200 shadow-sm ' +
          (loading ? '' : 'bg-white ') +
          (bardata && bardata.length === 0 ? 'pt-6 ' : '')
        }
      >
        {bardata && bardata.length === 0 && (
          <UserAlert
            para={`${xAxesLabel} data is not available`}
            paraClasses=' font-semibold text-gray-600'
            imgClasses=' h-5 w-5'
            classes=' p-4 ml-6 mr-4'
          />
        )}
        <Bargraph
          id='utilizationbargraph'
          loading={loading}
          loaderHeight={300}
          data={bardata}
          labels={barlabels}
          backgroundColor={barBgColors}
          height='300px'
          type='bar'
          ticks={{
            min: 0,
            max: 120,
            stepSize: 20,
          }}
          dataPoints='percentage'
          barTag='percentage'
          xAxesLabel={xAxesLabel}
          yAxesLabel='Utilization percentage'
        />
      </div>
    </div>
  );
};

export default HRA;
